import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=8b0d1e40&scoped=true"
import script from "./CreateDialog.vue?vue&type=script&lang=js"
export * from "./CreateDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateDialog.vue?vue&type=style&index=0&id=8b0d1e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0d1e40",
  null
  
)

export default component.exports